function FAQProgramsHeader(props) {

    const { status, setStatus } = props;

    return (
        <div id="faq-programs-header">
            <div className="flex-c">
                <div id="custom-tab-filters">

                    <div
                        className={status == "faq" ? "selected g-orange" : ""}
                        onClick={() => setStatus("faq")}
                    >
                        <h6>FAQ</h6>
                    </div>
                    <div
                        className={status == "programs" ? "selected g-orange" : ""}
                        onClick={() => setStatus("programs")}
                    >
                        <h6>Programs</h6>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FAQProgramsHeader;